module.exports = __webpack_public_path__ + "./Kimmy_color_16708609c26406bb906fcdce2fe17639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Kimmy_color.jpg
// module id = 596
// module chunks = 0